class Product{constructor(){this.acc=[],this.container=document.querySelector(".m-main-product"),MinimogTheme.CompareProduct&&MinimogTheme.CompareProduct.setCompareButtonsState(),MinimogTheme.Wishlist&&MinimogTheme.Wishlist.setWishlistButtonsState(),this.addRecentViewedProduct(),addEventDelegate({context:this.container,selector:(window.__minimog_review_selector||"")+".m-product-collapsible .jdgm-widget-actions-wrapper, .m-product-collapsible .spr-summary-actions-newreview",handler:e=>{const t=e.target.closest(".m-product-collapsible").dataset.index;setTimeout((()=>{this.acc[Number(t)].setContentHeight()}),300)},capture:!0})}addRecentViewedProduct(){const e=getCookie("m-recent-viewed-products");let t=e?JSON.parse(e):[];-1===t.indexOf(MinimogSettings.productHandle)&&(t.unshift(MinimogSettings.productHandle),t=t.slice(0,20),setCookie("m-recent-viewed-products",JSON.stringify(t)))}}

/* KarmaShop: estimare dinamică de livrare */
(() => {
  const TIME_ZONE = 'Europe/Bucharest';
  const CUTOFF_HOUR = 14;
  const DELIVERY_MIN_DAYS = 1;
  const DELIVERY_MAX_DAYS = 2;
  const FIXED_HOLIDAYS = [
    '01-01', '01-02', '01-06', '01-07', '01-24',
    '05-01', '06-01', '08-15', '11-30', '12-01',
    '12-25', '12-26'
  ];

  const EXTRA_CLOSED_DATES = [];

  const bucharestFormatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23'
  });

  const roMonthFormatter = new Intl.DateTimeFormat('ro-RO', {
    timeZone: 'UTC',
    month: 'long'
  });

  const getBucharestParts = (date) => {
    const parts = {};
    bucharestFormatter.formatToParts(date).forEach((part) => {
      if (part.type !== 'literal') parts[part.type] = Number(part.value);
    });
    return parts;
  };

  const dateKey = (date) => `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;
  const monthDayKey = (date) => `${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;

  const addCalendarDays = (date, days) => {
    const value = new Date(Date.UTC(date.year, date.month - 1, date.day + days));
    return {
      year: value.getUTCFullYear(),
      month: value.getUTCMonth() + 1,
      day: value.getUTCDate()
    };
  };

  const weekday = (date) => new Date(Date.UTC(date.year, date.month - 1, date.day)).getUTCDay();

  const orthodoxEaster = (year) => {
    const a = year % 4;
    const b = year % 7;
    const c = year % 19;
    const d = (19 * c + 15) % 30;
    const e = (2 * a + 4 * b - d + 34) % 7;
    const julianMonth = Math.floor((d + e + 114) / 31);
    const julianDay = ((d + e + 114) % 31) + 1;
    const value = new Date(Date.UTC(year, julianMonth - 1, julianDay + 13));
    return {
      year: value.getUTCFullYear(),
      month: value.getUTCMonth() + 1,
      day: value.getUTCDate()
    };
  };

  const movableHolidayKeys = (year) => {
    const easter = orthodoxEaster(year);
    return new Set([-2, 0, 1, 49, 50].map((offset) => dateKey(addCalendarDays(easter, offset))));
  };

  const isWorkingDay = (date) => {
    const day = weekday(date);
    if (day === 0 || day === 6) return false;
    if (FIXED_HOLIDAYS.includes(monthDayKey(date))) return false;
    if (EXTRA_CLOSED_DATES.includes(dateKey(date))) return false;
    if (movableHolidayKeys(date.year).has(dateKey(date))) return false;
    return true;
  };

  const nextWorkingDay = (date) => {
    let candidate = addCalendarDays(date, 1);
    while (!isWorkingDay(candidate)) candidate = addCalendarDays(candidate, 1);
    return candidate;
  };

  const addWorkingDays = (date, days) => {
    let candidate = date;
    let remaining = days;
    while (remaining > 0) {
      candidate = addCalendarDays(candidate, 1);
      if (isWorkingDay(candidate)) remaining -= 1;
    }
    return candidate;
  };

  const toUtcDate = (date) => new Date(Date.UTC(date.year, date.month - 1, date.day));
  const formatMonth = (date) => roMonthFormatter.format(toUtcDate(date));

  const formatDeliveryRange = (start, end) => {
    if (start.year === end.year && start.month === end.month) {
      return `${start.day}–${end.day} ${formatMonth(end)}`;
    }
    return `${start.day} ${formatMonth(start)}–${end.day} ${formatMonth(end)}`;
  };

  const formatCountdown = (now) => {
    const secondsUntilCutoff = (CUTOFF_HOUR * 60 * 60) - ((now.hour * 60 * 60) + (now.minute * 60) + now.second);
    const totalMinutes = Math.max(1, Math.ceil(secondsUntilCutoff / 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const parts = [];

    if (hours > 0) parts.push(`${hours} ${hours === 1 ? 'oră' : 'ore'}`);
    if (minutes > 0) parts.push(`${minutes} ${minutes === 1 ? 'minut' : 'minute'}`);

    return parts.join(' și ');
  };

  const getEstimate = () => {
    const now = getBucharestParts(new Date());
    const today = { year: now.year, month: now.month, day: now.day };
    const shipsToday = isWorkingDay(today) && now.hour < CUTOFF_HOUR;
    const dispatchDate = shipsToday ? today : nextWorkingDay(today);

    return {
      now,
      shipsToday,
      earliestDelivery: addWorkingDays(dispatchDate, DELIVERY_MIN_DAYS),
      latestDelivery: addWorkingDays(dispatchDate, DELIVERY_MAX_DAYS)
    };
  };

  const addStyles = () => {
    if (document.getElementById('ks-delivery-estimate-styles')) return;
    const style = document.createElement('style');
    style.id = 'ks-delivery-estimate-styles';
    style.textContent = `
      .ks-delivery-estimate{display:flex;align-items:flex-start;gap:10px;margin:12px 0 4px;padding:12px 14px;border:1px solid rgba(24,128,56,.22);border-radius:10px;background:rgba(236,253,245,.72);color:#183b25;font-size:14px;line-height:1.42}
      .ks-delivery-estimate[hidden]{display:none!important}
      .ks-delivery-estimate__icon{flex:0 0 auto;font-size:21px;line-height:1.2;margin-top:0}
      .ks-delivery-estimate__content,.ks-delivery-estimate__dispatch,.ks-delivery-estimate__arrival{display:block}
      .ks-delivery-estimate__dispatch{font-weight:650}
      .ks-delivery-estimate__arrival{margin-top:2px}
    `;
    document.head.appendChild(style);
  };

  const renderEstimate = (wrapper) => {
    const estimate = getEstimate();
    const deliveryRange = formatDeliveryRange(estimate.earliestDelivery, estimate.latestDelivery);

    wrapper.querySelector('.ks-delivery-estimate__dispatch').textContent =
      `Livrare estimată: ${deliveryRange}.`;

    wrapper.querySelector('.ks-delivery-estimate__arrival').textContent = estimate.shipsToday
      ? `Comandă în următoarele ${formatCountdown(estimate.now)} pentru acest interval de livrare.`
      : 'Comandă acum pentru acest interval de livrare.';
  };

  const createEstimateElement = () => {
    const wrapper = document.createElement('div');
    wrapper.className = 'ks-delivery-estimate';
    wrapper.setAttribute('aria-live', 'polite');
    wrapper.innerHTML = `
      <span class="ks-delivery-estimate__icon" aria-hidden="true">🚚</span>
      <span class="ks-delivery-estimate__content">
        <span class="ks-delivery-estimate__dispatch"></span>
        <span class="ks-delivery-estimate__arrival"></span>
      </span>
    `;

    renderEstimate(wrapper);
    return wrapper;
  };

  const initialize = () => {
    const productPage = document.querySelector('.m-main-product[data-section-type="product-page"]');
    if (!productPage || productPage.querySelector('.ks-delivery-estimate')) return;

    const productForm = productPage.querySelector('.m-product-form--main');
    if (!productForm) return;

    addStyles();
    const estimateElement = createEstimateElement();
    productForm.insertAdjacentElement('afterend', estimateElement);

    const addToCartButton = productForm.querySelector('.m-add-to-cart');
    const updateVisibility = () => {
      if (!addToCartButton) return;
      estimateElement.hidden = addToCartButton.classList.contains('disabled') || addToCartButton.disabled;
    };

    updateVisibility();
    if (addToCartButton) {
      new MutationObserver(updateVisibility).observe(addToCartButton, {
        attributes: true,
        attributeFilter: ['class', 'disabled']
      });
    }

    const refreshTimer = window.setInterval(() => renderEstimate(estimateElement), 60000);
    window.addEventListener('pagehide', () => window.clearInterval(refreshTimer), { once: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
